import React from "react";
import { Link } from "react-router-dom";
import { pageHref } from "./nav-config";

// The grouped link list shared by the desktop sidebar and the mobile sheet.
function NavGroups({ groups, activeKey, permissionsLoaded, onNavigate }) {
  return (
    <>
      {groups.map((group) => (
        <div className="rq-nav__group" key={group.label}>
          <p className="rq-nav__group-label">{group.label}</p>
          <ul className="rq-nav__list">
            {group.items.map((item) => {
              const isActive = item.key === activeKey;
              return (
                <li key={item.key}>
                  <Link
                    to={pageHref(item.key)}
                    className={`rq-nav__link ${
                      isActive ? "rq-nav__link--active" : ""
                    }`}
                    aria-current={isActive ? "page" : undefined}
                    data-tooltip={item.label}
                    onClick={onNavigate}
                  >
                    <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                    <span className="rq-nav__text">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}

      {!permissionsLoaded && (
        <div className="rq-nav__group" aria-hidden="true">
          <span className="rq-nav__skeleton rq-nav__skeleton--label" />
          <span className="rq-nav__skeleton" />
          <span className="rq-nav__skeleton" />
        </div>
      )}
    </>
  );
}

export default NavGroups;
